import { Box, styled } from '@mui/material'

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(0.5),
  borderRadius: theme.spacing(0.25),
  backgroundColor: theme.palette.black[12],
  position: 'relative',
  overflow: 'hidden'
}))

const Progress = styled(Box, { shouldForwardProp: (propName: string) => !['exceeded', 'value'].includes(propName) })<{
  exceeded: boolean
  value: number
}>(({ theme, exceeded, value }) => ({
  width: `${value}%`,
  height: '100%',
  position: 'absolute',
  backgroundColor: exceeded ? theme.palette.warning.main : theme.palette.secondary.main,
  borderRadius: theme.spacing(0.25),
  transition: theme.transitions.create(['width', 'left'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  })
}))

function Bar({ current, limit, overLimit }: { current: number; limit: number; overLimit?: boolean }) {
  return (
    <Root>
      <Progress exceeded={overLimit || current >= limit} value={limit ? (current / limit) * 100 : 0} />
    </Root>
  )
}
export default Bar
